module.exports = __webpack_public_path__ + "static/img/pop_up_bg.d50ed73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/claim/pop_up_bg.png
// module id = 9/WS
// module chunks = 1